import React, { Fragment, useState, useEffect } from 'react';
import Grid from "../../../Grid";
import Button from "../../../Button";
import { Controller, useForm } from 'react-hook-form';
import styles from "./DprojectStatusForm.module.sass";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Dproject from '../../../../models/Dproject';
import axios from 'axios';

const Form = ({ orderPackageId, isLink, closeModal }) => {
  const { register, handleSubmit, control, watch, setValue, setFocus, formState: { errors, isValid } } = useForm();
  const watchItemNumber = watch("order_package_id");
  const watchStatus = watch("status");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    setFocus('order_package_id');

    if (!orderPackageId) return;

    Dproject
      .find(orderPackageId)
      .then((response) => {
        setOrderPackage(response.data)
      });

    setValue('order_package_id', orderPackageId);
  }, [orderPackageId]);

  useEffect(() => {
    if (watchStatus) {
      setFocus('order_package_id');
    }
  }, [watchStatus, setFocus]);

  const focusOrderPackageId = () => {
    setFocus('order_package_id');
  };

  const onSubmit = (data) => {
      setIsSubmitting(true);
    	axios
        .post(`/api/v1/dprojects/mark_as_shipped`,
          { item:
              { shipper_initials: data.shipper_initials,
                id: data.order_package_id,
                status: data.status,
                received_by: data.received_by,
                ups_tracking: data.ups_tracking
              }
          })
        .then(() => {
          sendToastMessage(data.order_package_id);
          setValue('order_package_id', undefined);
          setIsSubmitting(false);
          focusOrderPackageId();
        })
        .catch(() => {
          sendFailToastMessage(data.order_package_id);
          setIsSubmitting(false);
          focusOrderPackageId();
        });
  }

  const sendToastMessage = (item_id) => {
    toast.success(`Project #${item_id} successfully Updated`, {
      position: "bottom-left",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }

  const sendFailToastMessage = (item_id) => {
    toast.error(`Project #${item_id} was not Updated. Please try again or check the ID number`, {
      position: "bottom-left",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }

  return (
    <Fragment>
      <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
        <Grid container justify='center' spacing={3}>
          <Grid item xs={4}>
            <label className={styles.label}>
              Shipper Initials *
            </label>

            <input
              className={styles.input}
              {...register("shipper_initials", { required: true })}
              onBlur={focusOrderPackageId}
            />
          </Grid>

          <Grid item xs={4}>
            <label className={styles.label}>
              Status *
            </label>

            <select
              className={`${styles.input} ${styles.select}`}
              {...register("status", { required: true })}
            >
              <option value="Printed">Printed</option>
              <option value="Packaged">Packaged</option>
              <option value="In Transit">In Transit</option>
              <option value="Shipped">Shipped</option>
              <option value="Delivered">Delivered</option>
            </select>
          </Grid>
        </Grid>

        <Grid container justify='center' spacing={3}>
          <Grid item xs={4}>
            <label className={styles.label}>
              Item Number *
            </label>

            <input
              className={styles.input}
              id="order_package_id"
              {...register("order_package_id", { required: true })}
            />
          </Grid>

          <Grid item xs={4}>
            <label className={styles.label}>
              Received By
            </label>

            <input
              name="received_by"
              className={styles.input}
              {...register("received_by")}
              onBlur={focusOrderPackageId}
            />
          </Grid>
        </Grid>

        <Grid container justify='center' spacing={3}>
          <Grid item xs={8}>
            <Button
              classes={styles.submit}
              fullWidth
              variant='submit'
              disabled={!watchItemNumber || isSubmitting}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </form>
    </Fragment>
  )
}

export default Form;